import { render } from "./ChurchDashboard.vue?vue&type=template&id=240b867e&scoped=true"
import script from "./ChurchDashboard.vue?vue&type=script&lang=js"
export * from "./ChurchDashboard.vue?vue&type=script&lang=js"

import "./ChurchDashboard.vue?vue&type=style&index=0&id=240b867e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-240b867e"]])

export default __exports__